<template>
    <div class="forex-page commo-indices-page">

        <BannerPages
            :title="'commodities.titleBanner'"
            :descriptions="[
                $t('commodities.descriptionBanner1'),
                $t('commodities.descriptionBanner2')
            ]"
            :img="'/images/commodities/2.Commodities-Img1.png'"
            mainImageWidthDesk="535"
            mainImageHeightDesk="570"
            alt="Trade Commodities & Energy with Tradeview Europe"
            :buttons="[
                {
                    type: 'external',
                    href: getExternalUrl('/register/1/live-account'),
                    class: 'primary-button-medium',
                    text: 'commodities.btn1' 
                },
                {
                    type: 'external',
                    href: getExternalUrl('/register/1/demo-account'),
                    class: 'second-button-medium-white',
                    text: 'commodities.btn2' 
                }
            ]"
        />

        <LazyToStarMam
            class="rigth_position margin-less"
            :title="$t('commodities.firstStart.title')"
            :imageSrc="'/images/commodities/4.Commodities-Img2.png'"
            :imageWidth="487"
            :imageHeight="401"
            imageAlt="img 2"
            :itemsList="firstItemsList"
            :style="degrade"
        />

        <LazyToStarMam
            class="min_cont"
            :title="$t('commodities.secondStart.title')"
            :imageSrc="'/images/commodities/5.Commodities-Img3.png'"
            :imageWidth="491"
            :imageHeight="358"
            imageAlt="img 2"
            :itemsList="secondItemsList"
        />

        <div class="margin-general">
            <div class="list-products">
                <div class="title_descript">
                    <h2>{{ $t("commodities.list-products.title") }}</h2>
                    <client-only>
                        <a target="_blank" :href="getExternalUrl('/register/1/live-account')" class="primary-button-medium"
                             rel="noopener noreferrer">
                                {{ $t("commodities.list-products.btn") }}
                            </a
                        >
                    </client-only>
                </div>
                <div class="cont_list">
                    <div class="title">
                        <p class="body-6-bold">{{ $t("commodities.list-products.subtitle") }}</p>
                        <p class="body-6-bold">{{ $t("commodities.list-products.subtitle2") }}</p>
                    </div>
                    <div class="list">
                        <p class="body-4">{{ $t("commodities.list-products.item1") }}</p>
                        <p class="body-4">{{ $t("commodities.list-products.item9") }}</p>
                    </div>
                    <div class="list">
                        <p class="body-4">{{ $t("commodities.list-products.item2") }}</p>
                        <p class="body-4">{{ $t("commodities.list-products.item10") }}</p>
                    </div>
                    <div class="list">
                        <p class="body-4">{{ $t("commodities.list-products.item3") }}</p>
                        <p class="body-4">{{ $t("commodities.list-products.item11") }}</p>
                    </div>
                    <div class="list">
                        <p class="body-4">{{ $t("commodities.list-products.item4") }}</p>
                        <p class="body-4">{{ $t("commodities.list-products.item12") }}</p>
                    </div>
                    <div class="list">
                        <p class="body-4">{{ $t("commodities.list-products.item5") }}</p>
                        <p class="body-4">{{ $t("commodities.list-products.item13") }}</p>
                    </div>
                    <div class="list">
                        <p class="body-4">{{ $t("commodities.list-products.item6") }}</p>
                        <p class="body-4">{{ $t("commodities.list-products.item14") }}</p>
                    </div>
                    <div class="list">
                        <p class="body-4">{{ $t("commodities.list-products.item7") }}</p>
                        <p class="body-4">{{ $t("commodities.list-products.item15") }}</p>
                    </div>
                    <div class="list">
                        <p class="body-4">{{ $t("commodities.list-products.item8") }}</p>
                        <p class="body-4">{{ $t("commodities.list-products.item16") }}</p>
                    </div>
                </div>
                <client-only>
                    <a target="_blank" class="btn2 primary-button-medium" :href="getExternalUrl('/register/1/live-account')"
                         rel="noopener noreferrer">
                            {{ $t("commodities.list-products.btn") }}
                       </a
                    >
                </client-only>
            </div>
        </div>

        <LazyPlatformSlider
            titleSection="commodities.platfor_slide.title"
            descriptionSection="commodities.platfor_slide.desc"
            :slider="slider"
            :style="degrade2"
            :slidesPerView="1"
            :spaceBetween="20"
            className="slideX3"
        />

        <LazyMoreResource
            :titleH2="'commodities.protectedTitle'"
            :cards="cardsSlideProtected"
            :padding="'padding-icon'"
            class="protected with-icons"
        />
        <client-only>
            <LazyInvestment
                :label="'commodities.ready'"
                :buttonConfigs="[
                    {
                        type: 'external',
                        href: getExternalUrl('/register/1/live-account'),
                        class: 'primary-button-medium',
                        textKey: 'commodities.btn-invest'
                    }
                ]"
            />
        </client-only>

    </div>
</template>
  
<script setup>
// import PreloaderPage from "~/components/PreloaderPage.vue";
import LazyToStarMam from "~/components/services/multi_mam/ToStarMam.vue";
import LazyPlatformSlider from "~/components/forex/PlatformsSlider.vue";
import LazyMoreResource from "~/components/home/MoreResource";
import LazyInvestment from "~/components/Investment";

import { useI18n } from "vue-i18n";
import { useExternalUrl } from '@/composables/useExternalUrl';
import { useImage } from '#imports';

const { t } = useI18n();
const { getExternalUrl } = useExternalUrl();

const nuxtImg = useImage();

const title = t("seo.commodities.title");
const description = t("seo.commodities.description");
const imgSeo = 'https://tradeview.eu/images/seo/22Commodities.jpg'

useSeoMeta({
    title: title,
    ogTitle: title,
    twitterTitle: title,
    description: description,
    ogDescription: description,
    twitterDescription: description,
    ogImage: imgSeo,
    twitterImage: imgSeo
});

const degradadeImageUrl = '/images/commodities/3.Commodities-Gradient1.avif';
const degradade2ImageUrl = '/images/commodities/6.Commodities-Gradient3.avif';

const optimizedDegrade = nuxtImg(degradadeImageUrl, {
  quality: 50,
  format: 'avif',
});
const optimizedDegrade2 = nuxtImg(degradade2ImageUrl , {
  quality: 50,
  format: 'avif',
});

const degrade = computed(() => {
  return {
    '--degrade': `url('${optimizedDegrade}')`,
  };
});

const degrade2 = computed(() => {
  return {
    '--degrade2': `url('${optimizedDegrade2}')`,
  };
});

const firstItemsList = ref([
    {
        type: 'paragraph',
        content: [
            { text: t("commodities.firstStart.item1"), strong: false },
        ]
    },
    {
        type: 'paragraph',
        content: [
            { text: t("commodities.firstStart.item2"), strong: false },
        ]
    },
]);

const secondItemsList = ref([
    {
        type: 'paragraph',
        content: [
            { text: t("commodities.secondStart.item1"), strong: false },
        ]
    },
]);

let slider = ref([
    /* {
        imgBackground: "/images/forex/backgound-mt4.png",
        title: "forex.mt4",
        description: [
            "commodities.platfor_slide.metatrader4Desc1",
            "commodities.platfor_slide.metatrader4Desc2",
            "commodities.platfor_slide.metatrader4Desc3",
            "commodities.platfor_slide.metatrader4Desc4",
            "commodities.platfor_slide.metatrader4Desc5",
        ],
        icon: "/images/forex/MT4-Icon.svg",
        alt: "Comodities on MT4",
    }, */
    {
        imgBackground: "/images/forex/background-mt5.png",
        title: "forex.mt5",
        description: [
            "commodities.platfor_slide.metatrader5Desc1",
            "commodities.platfor_slide.metatrader5Desc2",
            "commodities.platfor_slide.metatrader5Desc3",
            "commodities.platfor_slide.metatrader5Desc4",
            "commodities.platfor_slide.metatrader5Desc5",
        ],
        icon: "/images/futures/MT5-Icon.svg",
        alt: "Futures on MT5",
    },
]);

let cardsSlideProtected = ref([
    {
        icon: "sync",
        title: "commodities.protectedCardTitle1",
        desc: "commodities.protectedCardDesc1",
    },
    {
        icon: "account_balance_wallet",
        title: "commodities.protectedCardTitle2",
        desc: "commodities.protectedCardDesc2",
    },
    {
        icon: "lock",
        title: "commodities.protectedCardTitle3",
        desc: "commodities.protectedCardDesc3",
    },
    {
        icon: "acute",
        title: "commodities.protectedCardTitle4",
        desc: "commodities.protectedCardDesc4",
    },
]);

</script>